import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/orderserviceitem/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/orderserviceitem/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/orderserviceitem/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/orderserviceitem/save', params,options)

export const update = (params, options) =>
request.post('/api/orderserviceitem/update', params,options)
